export enum ImportError {
	import = "import_failed",
	action = "action_failed",
	duplicate = "duplicate_lead",
}